'use strict';

var SystemStatusOverbookingDirective = function SystemStatusOverbookingDirective() {
  return {
    restrict: 'E',
    template: require('../templates/system-status-overbooking.html'),
    controller: 'SystemStatusOverbookingController',
    link: function link(scope) {
      scope.$on('system-status-overbooking:reinitialize', scope.reinitialize);
      scope.$on('grid:afterUpdateBoundData', scope.forceAddRow);
    }
  };
};
SystemStatusOverbookingDirective.$inject = [];
module.exports = SystemStatusOverbookingDirective;